module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraBold.woff2?a0c781a9f8dd2c57ae264a4cd3fef718";